module.exports = __webpack_public_path__ + "static/you-inc-71f19c9f27962f4c17ccbaf2033b983d.jpg";